import { Spinner } from '@paysera/ui';
export const InlineSpinner = ({ isLoading }) => {
    if (!isLoading) {
        return null;
    }
    return (<div className="inline-flex">
            <Spinner className="w-4 h-4"/>
        </div>);
};
